// extracted by mini-css-extract-plugin
export var planCard = "_ss-0";
export var planList = "_ss-1";